module.exports = __webpack_public_path__ + "static/media/creativeshead.4e707b0c.jpg";